import { Radar } from 'lucide-react';
import { cn } from '@/shared/utils/cn';

interface WordmarkProps {
  className?: string;
  showText?: boolean;
}

/** Single source of truth for the product identity. */
export const Wordmark = ({ className, showText = true }: WordmarkProps) => (
  <div className={cn('flex items-center gap-2', className)}>
    <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary/10 text-primary">
      <Radar className="h-5 w-5" />
    </span>
    {showText && (
      <span className="text-md font-semibold tracking-tight text-foreground">UpdateRadar</span>
    )}
  </div>
);
